import {createSvgIcon} from '../create-svg-icon';

export const ArrowLeftIcon = createSvgIcon(
  <path d="m14 7-5 5 5 5V7z" />
, 'ArrowLeftOutlined');
